import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { LlmInfo } from "@/shared/api/useGetLlmInfoList";
import { useEffect } from "react";

interface ModelSelectorProps {
  selectedLlmName: string | undefined;
  onLlmChange: (llmName: string) => void;
  llmInfo: LlmInfo[];
}

function MetricBars({ value, label }: { value: number; label: string }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-gray-500 w-[60px]">{label}</span>
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((level) => (
          <div
            key={level}
            className={`w-[18px] h-[4px] rounded-sm transition-colors ${
              level <= value ? "bg-gray-800" : "bg-gray-200"
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export function ModelSelector({
  selectedLlmName,
  onLlmChange,
  llmInfo,
}: ModelSelectorProps) {
  const selectedLlmInfo = llmInfo.find((info) => info.name === selectedLlmName);

  useEffect(() => {
    if (!llmInfo.length || selectedLlmName) return;
    onLlmChange(llmInfo[0].name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [llmInfo]);

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-gray-700">Choose model:</span>
      <Select value={selectedLlmName || ""} onValueChange={onLlmChange}>
        <SelectTrigger className="w-[300px] h-9 bg-white text-sm">
          <SelectValue>
            {selectedLlmInfo?.displayName || "Select a model"}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {llmInfo.map((info) => (
            <SelectItem
              key={info.name}
              value={info.name}
              className="text-sm py-3 cursor-pointer hover:bg-gray-50"
            >
              <div className="space-y-2">
                <div>
                  <div className="font-medium">{info.displayName}</div>
                  <div className="text-xs text-gray-500 mt-0.5">
                    {info.description}
                  </div>
                </div>
                <div className="space-y-2">
                  <MetricBars value={info.intelligence} label="Intelligence" />
                  <MetricBars value={info.speed} label="Speed" />
                </div>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
